import { render, staticRenderFns } from "./qu-est-ce-que-le-delegated-proof-of-stake-dpos.vue?vue&type=template&id=a44fa372&"
import script from "./qu-est-ce-que-le-delegated-proof-of-stake-dpos.vue?vue&type=script&lang=js&"
export * from "./qu-est-ce-que-le-delegated-proof-of-stake-dpos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules_dev/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports